import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.sites.length > 0 ? _c('div', {
    staticClass: "tw-map-siteNameList",
    attrs: {
      "id": "siteNameList"
    }
  }, _vm._l(_vm.sites, function (site, index) {
    return _c('p', {
      key: site.id || "".concat(site.county, "-").concat(site.lat, "-").concat(site.lon),
      class: {
        'highlighted': _vm.selectedIndex === index
      },
      on: {
        "click": function click($event) {
          return _vm.selectSite(index, site);
        }
      }
    }, [_vm._v(" " + _vm._s((index + 1).toString().padStart(2, '0')) + ". " + _vm._s(site.name) + " ")]);
  }), 0) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };